/** True when the event target is a text-editing element (input/textarea/
 *  contenteditable) — used to suppress single-key keyboard shortcuts while the
 *  user is typing. Shared by the entry-selection hook, the Feeds page, and the
 *  right sidebar so all three agree on what "typing" means. */
export function isTypingTarget(el: EventTarget | null): boolean {
  return (
    el instanceof HTMLElement &&
    (el.tagName === "INPUT" || el.tagName === "TEXTAREA" || el.isContentEditable)
  );
}
